module.exports = __webpack_public_path__ + "h5/img/touxiang.f52281dd.png";